import { slideUp, slideDown, slideToggle } from './libs/slide';

document.addEventListener('DOMContentLoaded', function () {
  const addEventTermButton = document.getElementById('add-event-term');

  if (addEventTermButton) {
    const eventTermsForm = document.getElementById('event-terms');

    const maxIndex = parseInt(addEventTermButton.dataset.maxIndex);
    let eventTermIndex = maxIndex;

    addEventTermButton.addEventListener('click', function () {
      const newEventTermForm = document.createElement('div');
      newEventTermForm.classList.add('event-term');

      newEventTermForm.innerHTML = `
        <div class="input-date">
          <div class="input-date-box">
            <label for="event_application_event_terms_attributes_${eventTermIndex}_start_date" class="input-date-box__label">開始</label>
            <input type="date" id="event_application_event_terms_attributes_${eventTermIndex}_start_date" name="event_application[event_terms_attributes][${eventTermIndex}][start_date]">
          </div>
          <div class="input-date-box">
            <label for="event_application_event_terms_attributes_${eventTermIndex}_end_date" class="input-date-box__label">終了</label>
            <input type="date" id="event_application_event_terms_attributes_${eventTermIndex}_end_date" name="event_application[event_terms_attributes][${eventTermIndex}][end_date]">
          </div>
        </div>
      `;

      eventTermsForm.appendChild(newEventTermForm);
      eventTermIndex++;
    });

    if (eventTermIndex === 0) {
      addEventTermButton.click();
    }
  }

  const addEventInquiryUrlButton = document.getElementById('add-event-inquiry-url');

  if (addEventInquiryUrlButton) {
    const eventInquiryUrlsForm = document.getElementById('event-inquiry-urls');

    const maxIndex = parseInt(addEventInquiryUrlButton.dataset.maxIndex);
    let eventInquiryUrlIndex = maxIndex;

    addEventInquiryUrlButton.addEventListener('click', function () {
      const newEventInquiryUrlForm = document.createElement('div');
      newEventInquiryUrlForm.classList.add('event-inquiry-url');

      newEventInquiryUrlForm.innerHTML = `
        <div class="input-text mb-1">
          <input type="url" id="event_application_event_inquiry_urls_attributes_${eventInquiryUrlIndex}_url" name="event_application[event_inquiry_urls_attributes][${eventInquiryUrlIndex}][url]">
        </div>
      `;

      eventInquiryUrlsForm.appendChild(newEventInquiryUrlForm);
      eventInquiryUrlIndex++;
    });

    if (eventInquiryUrlIndex === 0) {
      addEventInquiryUrlButton.click();
    }
  }

  // 参加予約が必要な場合のみ予約受付期間入力欄を表示
  const reservationContainer = document.querySelector('.reservation-acceptance-period');
  const reservationRadios = document.querySelector('[data-role="required-reservation-check"]');
  if (!reservationContainer || !reservationRadios) return;
  reservationRadios.addEventListener('change', (event) => {
    if (event.target.value === 'true') {
      slideDown(reservationContainer, 300);
    } else {
      slideUp(reservationContainer, 300);
    }
  });

  // 画像削除ボタンが押された場合
  const deleteImageButtons = document.querySelectorAll('[id *= "event_remove_image_button_"]');
  deleteImageButtons.forEach((buttonElement) => {
    buttonElement.addEventListener(
      'click',
      (e) => {
        // 画像を一旦非表示にする
        buttonElement
          .closest('div.event-image-field')
          .querySelector('.preview_event_image')
          .classList.toggle('d-none', true);
        // 削除フラグに[1]を設定する
        e.target.querySelector('input[type=checkbox]').checked = true;
      },
      { once: true }
    );
  });

  // Item削除ボタンが押された場合
  const deleteItemButtons = document.querySelectorAll('[id *= "event_remove_item_button_"]');
  deleteItemButtons.forEach((buttonElement) => {
    buttonElement.addEventListener(
      'click',
      (e) => {
        // 画像を一旦非表示にする
        buttonElement
          .closest('div.event-item-field')
          .querySelector('.preview_event_item')
          .classList.toggle('d-none', true);
        // 削除フラグに[1]を設定する
        e.target.querySelector('input[type=checkbox]').checked = true;
      },
      { once: true }
    );
  });

  // 戻るボタンで戻ってきた場合にファイル選択に画像ファイルを設定する
  const imageUrlElements = document.querySelectorAll('[id *= "event_image_url_"]');
  imageUrlElements.forEach((imageUrlElement) => {
    if (imageUrlElement.value) {
      fetch(imageUrlElement.value.split(',')[0]).then(async (res) => {
        const contentType = await res.headers.get('Content-Type');
        const blob = await res.blob();
        const file = new File([blob], imageUrlElement.value.split(',')[1], { contentType });
        const dt = new DataTransfer();
        dt.items.add(file);
        imageUrlElement.closest('div.event-image-field').querySelector('input[type="file"]').files = dt.files;
      });
    }
  });

  // 戻るボタンで戻ってきた場合にファイル選択にItemファイルを設定する
  const itemUrlElements = document.querySelectorAll('[id *= "event_item_url_"]');
  itemUrlElements.forEach((itemUrlElement) => {
    if (itemUrlElement.value) {
      fetch(itemUrlElement.value.split(',')[0]).then(async (res) => {
        const contentType = await res.headers.get('Content-Type');
        const blob = await res.blob();
        const file = new File([blob], itemUrlElement.value.split(',')[1], { contentType });
        const dt = new DataTransfer();
        dt.items.add(file);
        itemUrlElement.closest('div.event-item-field').querySelector('input[type="file"]').files = dt.files;
      });
    }
  });

  // 画像が設定された場合にプレビュー表示を行う
  const imageElements = document.querySelectorAll('[id^="event_"][id$="_image"]');
  imageElements.forEach((imageElement) => {
    imageElement.addEventListener('change', (e) => {
      const parentElement = e.target.closest('div.event-image-field');
      const imgDivElement = parentElement.querySelector('div.preview_event_image');
      const [file] = e.target.files;

      if (file) {
        const img = document.createElement('img');
        img.setAttribute('src', URL.createObjectURL(file));
        img.style.width = '300px';
        imgDivElement.appendChild(img);
      } else {
        imgDivElement.classList.toggle('d-none', true);
      }
    });
  });

  // 個人情報保護方針に同意すると確認ボタンが有効化する
  const agreeCheckbox = document.querySelector('.acceptance-check');
  const confirmBtn = document.querySelector('.confirm-btn');
  agreeCheckbox?.addEventListener('click', () => {
    if (agreeCheckbox.checked === true) {
      confirmBtn.classList.remove('is-disable');
    } else {
      confirmBtn.classList.add('is-disable');
    }
  });
});
